module.exports = __webpack_public_path__ + "static/img/icon-video-fill.1a3b4b92.svg";